export const styles = {
  animatedContainer: {
    overflow: 'clip',
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  } as const,
  animatedContent: {
    position: 'relative',
    flex: 1,
    overflow: 'auto',
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  } as const
}
